import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-sanction-grid',
  templateUrl: './payroll-sanction-grid.component.html',
  styleUrls: ['./payroll-sanction-grid.component.css']
})
export class PayrollSanctionGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-grid/payroll-sanction-grid.component.ts